<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.change_profile') }}
              </div>
              <v-spacer />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <ValidationObserver ref="observer" v-slot="{ invalid, validated, passes, validate }">
            <div class="mt-2 mb-10">
              <!-- <select-slider :items="avatars" /> -->
              <slick ref="slick" :options="slickOptions">
                <div v-for="(item, i) in avatars" :key="i">
                  <div class="avatar-slide-item">
                    <img :src="item.img_path" :alt="item.name" class="image-responsive">
                  </div>
                </div>
              </slick>
            </div>
            <div>
              <label class="font-12">{{ $t('v2.name') }}</label>
              <ValidationProvider v-slot="{ errors, valid }" name="name" rules="required">
                <v-text-field v-model="form.name" outlined heigth="40" dense :error-messages="errors" class="inputv2-space" />
              </ValidationProvider>
            </div>
            <div>
              <label class="font-12">{{ $t('v2.gender') }}</label>
              <ValidationProvider v-slot="{ errors, valid }" name="gender" rules="required">
                <v-select v-model="form.gender" :items="gender" outlined heigth="40" item-value="id" item-text="name" :menu-props="{ offsetY: true }" dense :error-messages="errors" class="inputv2-space" />
              </ValidationProvider>
            </div>
            <div>
              <div class="flex-image">
                <div class="flex-image-content">
                  <div class="flex-image-content-text ol-black font-12">
                    {{ $t('v2.phone_number') }}
                  </div>
                  <div class="flex-image-content-text font-14 font-weight-600">
                    {{ formatPhone }}
                  </div>
                </div>
                <v-btn :to="{ name: '_select_otp' }" text class="text-none letter-spacing-normal font-16 font-weight-700 ol-brand ml-2">
                  {{ $t('v2.change2') }}
                </v-btn>
              </div>
            </div>
            <div class="section-bottom">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                    <v-btn block color="primary" height="40" class="text-none br-5" @click="updateAccount()">
                      {{ $t('v2.next') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </ValidationObserver>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { debounce } from 'debounce'
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import {
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'
import {
  getData as getCustomer,
  getDataAvatar as getAvatar,
  updateData
} from '@/api/customer'
export default {
  components: {
    // SelectSlider,
    Slick,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      slickOptions: {
        centerMode: true,
        centerPadding: '24px',
        slidesToShow: 3,
        arrows: false
      },
      avatars: [],
      customer: {},
      form: {
        name: '',
        gender: '',
        avatar_id: ''
      },
      gender: [
        { id: 'M', name: this.$t('v2.male') },
        { id: 'F', name: this.$t('v2.female') }
      ]
    }
  },
  computed: {
    formatPhone() {
      let new_phone = ''
      if (typeof this.customer.phone !== 'undefined') {
        const arrPhone = this.customer.phone.split('')
        for (let i = 0; i < arrPhone.length; i++) {
          if (i !== (arrPhone.length - 1) && i !== (arrPhone.length - 2) && i !== (arrPhone.length - 3)) {
            arrPhone[i] = 'x'
          }
        }
        new_phone = arrPhone.join('')
      }
      return new_phone
    }
  },
  created() {
    this.getListAvatar()
  },
  mounted() {
    this.getDataCustomer()
  },
  methods: {
    reInit() {
      let currIndex = this.$refs.slick.currentSlide()
      if (this.customer.avatar_id) {
        currIndex = Number(this.customer.avatar_id) - 1
      }
      this.$refs.slick.destroy()
      this.$nextTick(() => {
        this.$refs.slick.create()
        this.$refs.slick.goTo(currIndex, true)
      })
    },
    goBack() {
      this.$router.push({ name: '_menu' }).catch(() => {})
    },
    async getDataCustomer() {
      try {
        const { data } = await getCustomer()
        this.customer = data.data
        this.form.name = this.customer.name
        this.form.gender = this.customer.gender
      } catch (e) {
        this.customer = {}
      }
    },
    async updateAccount() {
      const isValid = await this.$refs.observer.validate()
      if (isValid) {
        try {
          this.form.avatar_id = Number(this.$refs.slick.currentSlide()) + 1
          await updateData(this.form)
          this.$store.state.show_error = true
          this.$store.state.error_message = this.$t('v2.successfully_changed_profile')
          this.$store.state.error_type = 200
          this.$router.push({ name: '_menu' }).catch(() => {})
        } catch (e) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    getListAvatar: debounce(async function() {
      try {
        const { data } = await getAvatar()
        this.avatars = data.data
        this.reInit()
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }, 500)
  }
}
</script>
